// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Display from 'components/display'
import Cover from 'components/cover'
import PrivacyPolicy from 'components/privacyPolicy'
import { Waypoint } from 'react-waypoint'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'

const ARTICLE_ID = '12625467'
let teaserIds = ['24604585', '26421603', '24261650']
const isMobile = window.innerWidth < 720

function AppComponent() {
  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} additionalShares={111} />
      <ThemeSwitch />

      <header className='ui vertical fitted segment' style={{ padding: '0' }}>
        <Cover
          title='Das sagt Ihr Musikgeschmack über Sie aus'
          subtitle={
            isMobile
              ? 'Zu welcher Sound-Generation gehören Sie? Wir analysieren Ihre Musikbibliothek.'
              : 'Sind Sie der Mainstream-Typ? Oder die Dance-Queen? Zu welcher Sound-Generation gehören Sie? Wir analysieren Ihre Musikbibliothek.'
          }
        />
        <div className='ui very fitted vertical segment cover-caption'>
          <div className='ui container'>
            <p className='ta secondary caption'>
              Fotos: Gettyimages, Keystone. Animation: Mathias Lutz.
            </p>
          </div>
        </div>
      </header>

      <div
        className='ui vertical fitted segment'
        style={{ paddingBottom: '0.5em' }}
      >
        <div className='ui text container'>
          <p className='ta author' style={{ paddingTop: '2em' }}>
            Von Patrick Meier, Philippe Zweifel und Mathias Lutz
          </p>

          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: 'startReading'
                })
              }
            }}
          />

          <p>
            Sind Babyboomer höflicher als Millennials? Sind sie sexuell
            zugeknöpfter als ihre Nachgeborenen? Natürlich sind solche
            Generationen-Charakterisierungen Pauschalurteile und können für den
            Einzelnen falsch sein. Und doch steckt meistens eine Wahrheit in
            ihnen, wie auch die soziologische Definition zeigt: Eine Generation
            ist eine Altersgruppe, die durch gemeinsame
            historisch-gesellschaftliche Ereignisse und Einwirkungen geprägt
            wurde.
          </p>
          <p>
            Dies gilt ganz besonders für Musik. Wer in den 80ern aufwuchs, der
            ist auf ewig immun gegen die klebrigen Hits von damals. Alt-68er
            besuchen auch heute noch Stones-Konzerte. Wir wollten es aber
            genauer wissen und analysierten Spotify-Datensätze, um
            herauszufinden, wie sich die Generationen in ihrem Musikgeschmack
            unterscheiden. Hören junge Menschen positivere Musik als ältere? Wer
            hats lieber energetisch? Wer akustisch? Und vor allem: Wo
            positionieren Sie sich innerhalb dieser Trends? Wie alt sind Sie
            musikalisch gesehen? Unser interaktives Tool zeigt auch dies. Machen
            Sie mit!
          </p>
          <p>Zur Erinnerung, so sind die Generationen definiert:</p>
          <ul className='gen-definition'>
            <li>
              <strong>GENERATION Z:</strong> &nbsp;&nbsp;
              {isMobile
                ? 'ab 1994 geboren'
                : 'ab 1994 geboren, jünger als 25 Jahre'}
            </li>
            <li>
              <strong>GENERATION Y:</strong> &nbsp;&nbsp;
              {isMobile
                ? '1981–1994 geboren'
                : '1981–1994 geboren, zwischen 25 und 38 Jahre alt'}
            </li>
            <li>
              <strong>GENERATION X:</strong> &nbsp;&nbsp;
              {isMobile
                ? '1965–1980 geboren'
                : '1965–1980 geboren, zwischen 39 und 54 Jahre alt'}
            </li>
            <li>
              <strong>BABYBOOMER:</strong> &nbsp;&nbsp;
              {isMobile
                ? '1946–1964 geboren'
                : '1946–1964 geboren, zwischen 55 und 73 Jahre alt'}
            </li>
          </ul>
        </div>
      </div>

      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'vertical-scroll',
              event_label: '25ContentRead'
            })
          }
        }}
      />

      {/* START srsly content */}
      <Display />
      {/* END srsly content */}

      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'vertical-scroll',
              event_label: 'contentBottom'
            })
          }
        }}
      />

      <div className='ui vertical fitted attached segment'>
        <div className='ui container section'>
          <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
          <ArticleTeasers
            sorting='reverse chronologically by creation date'
            numberOfCards='three'
            articleIds={teaserIds}
          />
        </div>
      </div>

      <div className='ui vertical fitted attached segment' id='methodik'>
        <div
          className='ui text container methodik'
          style={{ position: 'relative', paddingTop: '1em' }}
        >
          <h4 style={{ fontSize: '1.4em' }}>Methodik</h4>

          <p>
            Spotify speichert zu jedem Song unterschiedliche Eigenschaften wie
            Fröhlichkeit oder Tanzbarkeit ab (
            <a href='https://developer.spotify.com/documentation/web-api/reference/tracks/get-audio-features'>
              Mehr Infos hier
            </a>
            ). Konkret wurden für diese Analyse die Werte für Fröhlichkeit,
            Energie, Tanzbarkeit, Anteil Sprechgesang, Liveanteil,
            Akustikanteil, Popularität und Songlänge genutzt. Zusätzlich haben
            wir von Spotify die 100 meistgespielten Songs der jeweiligen
            Generation erhalten (Zeitraum 1.4.2018 bis 1.4.2019). Von diesen
            wurden dann über die öffentlich zugängliche Programmierschnittstelle
            (API) von Spotify die oben genannten Eigenschaften abgefragt und die
            Durchschnittswerte für die jeweilige Generation gebildet. Diese
            Durchschnittswerte werden in den Liniengrafiken dargestellt. Alle
            Eigenschaften (ausser Songlänge) sind per Definition zwischen 0 und
            1. Wir haben bewusst darauf verzichtet, diese Werte auf der Y-Achse
            anzugeben, da sie sehr abstrakt und wenig hilfreich bei der
            Interpretation sind.
          </p>
          <p>
            Spotify ermittelt für jeden User, welche Songs er in den letzten 6
            Monaten am häufigsten gehört hat, wobei kürzlich gehörte Songs
            stärker gewichtet werden. Dies sind{' '}
            <a href='https://developer.spotify.com/documentation/web-api/reference/personalization/get-users-top-artists-and-tracks'>
              Ihre Top 100 Songs
            </a>
            . Wenn Sie sich entscheiden, Ihren eigenen Musikgeschmack zu
            analysieren (über den Button «Mitmachen»), werden von Ihrem
            Spotify-Account Ihre 100-Top-Songs ausgelesen. Von diesen werden
            dann die gleichen Eigenschaften wie für die verschiedenen
            Generationen abgefragt. Dann werden ebenfalls die Mittelwerte
            gebildet und in den Grafiken dargestellt (blauer Punkt). Zusätzlich
            werden auch die Durchschnittswerte von allen Usern, die mitgemacht
            haben, berechnet und dargestellt (grüner Punkt). Somit können Sie
            Ihren Musikgeschmack mit den verschiedenen Generationen sowie dem
            Durchschnitt aller User, die mitgemacht haben, vergleichen.Ihre
            eigenen Werte fliessen ebenfalls in die Werte des
            Tamedia-Durchschnitts ein.
          </p>

          <h5>Berechnung des musikalischen Alters</h5>
          <p>
            Für alle Eigenschaften wurde jeweils eine lineare Regression auf das
            Alter durchgeführt. Mit den so erhaltenen Koeffizienten lässt sich
            das Alter aufgrund des Durchschnittswerts einer bestimmten
            Eigenschaft vorhersagen. Diese vorhergesagten Werte werden dann auf
            minimal 16 und maximal 73 Jahre begrenzt. Danach wird der
            Durchschnittswert aller dieser vorhergesagten Alterswerte gebildet.
            Die Werte für Anteil Sprechgesang, Tanzbarkeit, Liveness und
            Songlänge werden dabei doppelt gewichtet, da sie einen besonders
            deutlichen Trend für das Alter zeigen. Der Wert für Akustikanteil
            wird hingegen nicht berücksichtigt, da er keinen klaren Trend zeigt.
          </p>
          <p>
            Wir haben einige Beispiele, wie die Spotify-Programmierschnittstelle
            (API) verwendet werden kann, um die beschriebenen Analysen
            durchzuführen, auf{' '}
            <a href='https://github.com/tamedia-ddj/Spotify-Musical-Taste'>
              Github dokumentiert
            </a>
            . Die Listen mit den Top-100-Songs der verschiedenen Generationen
            sind ebenfalls dort verfügbar.
          </p>

          <h4 style={{ fontSize: '1.4em' }}>Datenschutz</h4>

          <div className='list'>
            <p>
              Ihre Privatsphäre ist uns wichtig. Diese Datenschutzerklärung
              informiert über die Daten, die wir für die Musikgeschmack-Analyse
              erheben.
            </p>

            <PrivacyPolicy />
          </div>
        </div>
      </div>

      <Waypoint
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'vertical-scroll',
              event_label: 'pageBottom'
            })
          }
        }}
      />

      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Text, Methodik und Recherche', 'Patrick Meier, Philippe Zweifel'],
          [
            'Interaktives Konzept und Gestaltung',
            'Mathias Lutz, Interaktiv-Team'
          ],
          [
            'Programmierung',
            '<a href="https://www.srsly.ch">SRSLY</a> und Mathias Lutz'
          ]
        ]}
        hidePortfolioTeaser
        mailTo={'daten@tamedia.ch'}
      />
    </div>
  )
}

export default hot(AppComponent)
